"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PaletteBlock = require("./PaletteBlock");
Object.keys(_PaletteBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlock[key];
    }
  });
});
var _PaletteChildBlock = require("./PaletteChildBlock");
Object.keys(_PaletteChildBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteChildBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteChildBlock[key];
    }
  });
});
var _PaletteColors = require("./PaletteColors");
Object.keys(_PaletteColors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteColors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteColors[key];
    }
  });
});
var _PaletteMainPage = require("./PaletteMainPage");
Object.keys(_PaletteMainPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteMainPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteMainPage[key];
    }
  });
});
var _PalettePage = require("./PalettePage");
Object.keys(_PalettePage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PalettePage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PalettePage[key];
    }
  });
});
var _Palette = require("./Palette");
Object.keys(_Palette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Palette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Palette[key];
    }
  });
});
var _PaletteStyle = require("./PaletteStyle");
Object.keys(_PaletteStyle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteStyle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteStyle[key];
    }
  });
});
var _PaletteBlockBalance = require("./PaletteBlockBalance");
Object.keys(_PaletteBlockBalance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockBalance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockBalance[key];
    }
  });
});
var _PaletteBlockCheckbox = require("./PaletteBlockCheckbox");
Object.keys(_PaletteBlockCheckbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockCheckbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockCheckbox[key];
    }
  });
});
var _PaletteBlockCondition = require("./PaletteBlockCondition");
Object.keys(_PaletteBlockCondition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockCondition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockCondition[key];
    }
  });
});
var _PaletteBlockContract = require("./PaletteBlockContract");
Object.keys(_PaletteBlockContract).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockContract[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockContract[key];
    }
  });
});
var _PaletteBlockContribToken = require("./PaletteBlockContribToken");
Object.keys(_PaletteBlockContribToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockContribToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockContribToken[key];
    }
  });
});
var _PaletteBlockDumbapp = require("./PaletteBlockDumbapp");
Object.keys(_PaletteBlockDumbapp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockDumbapp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockDumbapp[key];
    }
  });
});
var _PaletteBlockImage = require("./PaletteBlockImage");
Object.keys(_PaletteBlockImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockImage[key];
    }
  });
});
var _PaletteBlockInput = require("./PaletteBlockInput");
Object.keys(_PaletteBlockInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockInput[key];
    }
  });
});
var _PaletteBlockLayout = require("./PaletteBlockLayout");
Object.keys(_PaletteBlockLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockLayout[key];
    }
  });
});
var _PaletteBlockNft = require("./PaletteBlockNft");
Object.keys(_PaletteBlockNft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockNft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockNft[key];
    }
  });
});
var _PaletteBlockRepeatSelect = require("./PaletteBlockRepeatSelect");
Object.keys(_PaletteBlockRepeatSelect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockRepeatSelect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockRepeatSelect[key];
    }
  });
});
var _PaletteBlockRepeat = require("./PaletteBlockRepeat");
Object.keys(_PaletteBlockRepeat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockRepeat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockRepeat[key];
    }
  });
});
var _PaletteBlockSpinner = require("./PaletteBlockSpinner");
Object.keys(_PaletteBlockSpinner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockSpinner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockSpinner[key];
    }
  });
});
var _PaletteBlockTemplate = require("./PaletteBlockTemplate");
Object.keys(_PaletteBlockTemplate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockTemplate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockTemplate[key];
    }
  });
});
var _PaletteBlockWallet = require("./PaletteBlockWallet");
Object.keys(_PaletteBlockWallet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockWallet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockWallet[key];
    }
  });
});
var _PaletteActionLink = require("./PaletteActionLink");
Object.keys(_PaletteActionLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteActionLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteActionLink[key];
    }
  });
});
var _PaletteActionPage = require("./PaletteActionPage");
Object.keys(_PaletteActionPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteActionPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteActionPage[key];
    }
  });
});
var _PaletteBlockInteraction = require("./PaletteBlockInteraction");
Object.keys(_PaletteBlockInteraction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteBlockInteraction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteBlockInteraction[key];
    }
  });
});
var _PaletteInteractionClick = require("./PaletteInteractionClick");
Object.keys(_PaletteInteractionClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteInteractionClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteInteractionClick[key];
    }
  });
});
var _PaletteVariableInteraction = require("./PaletteVariableInteraction");
Object.keys(_PaletteVariableInteraction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteVariableInteraction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteVariableInteraction[key];
    }
  });
});
var _PaletteDumbappTriggerComplete = require("./PaletteDumbappTriggerComplete");
Object.keys(_PaletteDumbappTriggerComplete).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteDumbappTriggerComplete[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteDumbappTriggerComplete[key];
    }
  });
});
var _PaletteDumbappTriggerHash = require("./PaletteDumbappTriggerHash");
Object.keys(_PaletteDumbappTriggerHash).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteDumbappTriggerHash[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteDumbappTriggerHash[key];
    }
  });
});
var _PaletteDumbappTriggerSubmit = require("./PaletteDumbappTriggerSubmit");
Object.keys(_PaletteDumbappTriggerSubmit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PaletteDumbappTriggerSubmit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaletteDumbappTriggerSubmit[key];
    }
  });
});
//# sourceMappingURL=index.js.map